import { render } from "./IconArrowForward.vue?vue&type=template&id=58452b32"
import script from "./IconArrowForward.vue?vue&type=script&lang=js"
export * from "./IconArrowForward.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__